<template>
  <b-modal title="Informações do Cliente" v-model="show" size="lg">
    <b-container fluid>
      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Nome:" label-for="nome" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="nome" v-model="editing.nome" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="11">
          <b-form-group label="CNPJ:" label-for="cnpj" label-cols-sm="3" label-align-sm="right"
            ><b-form-input id="cnpj" v-model="editing.cnpj" v-mask="'##.###.###/####-##'" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="11">
          <b-form-group label="Endereço:" label-for="endereco" label-cols-sm="3" label-align-sm="right"
            ><b-form-input id="endereco" v-model="editing.endereco" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="11">
          <b-form-group label="Bairro:" label-for="bairro" label-cols-sm="3" label-align-sm="right"
            ><b-form-input id="bairro" v-model="editing.bairro" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="11">
          <b-form-group label="Cidade:" label-for="cidade" label-cols-sm="3" label-align-sm="right"
            ><b-form-input id="cidade" v-model="editing.cidade" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="11">
          <b-form-group label="UF:" label-for="uf" label-cols-sm="3" label-align-sm="right"
            ><b-form-select id="uf" v-model="editing.uf" :options="estados.brasil" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="11">
          <b-form-group label="Telefone:" label-for="telefone" label-cols-sm="3" label-align-sm="right"
            ><b-form-input id="telefone" v-model="editing.telefone" v-mask="['(##) ####-####', '(##) #####-####']" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="11">
          <b-form-group label="E-mail:" label-for="email" label-cols-sm="3" label-align-sm="right"
            ><b-form-input id="email" v-model="editing.email" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="11">
          <b-form-group label="Logomarca:" label-cols-sm="3" label-align-sm="right">
            <b-form-file
              type="file"
              class="text-left mt-1"
              v-model="arquivo"
              placeholder="Solte as fotos o da logo .jpg"
              drop-placeholder="Solte o arquivo da logo .jpg"
              accept=".jpg"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>

    <template #modal-footer>
      <b-button variant="primary" @click="salvar()">Salvar</b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { useClienteStore } from "@/stores/ClienteStore";
import Cliente from "@/models/Cliente";
import EstadosUF from "@/tools/EstadosUF";
import Notificacao from "@/models/Notificacao";
import Files from "@/http/files";

export default {
  name: "ModalDeEdicaoDeCliente",

  data() {
    return {
      show: false,
      editing: new Cliente(0, "", "", "", "", "", "", "", ""),
      estados: new EstadosUF(),
      files: new Files(this.$http),
      arquivo: null,
    };
  },

  methods: {
    salvar() {
      if (this.editing.id != 0) {
        this.clienteStore.ALTERAR_CLIENTE(this.editing).then(() => {
          this.store.NOTIFICAR(new Notificacao("Cliente salvo no SGCQ com sucesso!", "Excelente!", "success"));
          if (this.arquivo != null) {
            const filename = this.editing.id + ".jpg";
            let formData = new FormData();
            formData.append("name", this.arquivo.name);
            formData.append("file", this.arquivo);
            this.files.uploadLogo(filename, formData);
          }
        });
      } else {
        this.clienteStore
          .CADASTRAR_CLIENTE(this.editing)
          .then(() => this.store.NOTIFICAR(new Notificacao("Cliente salvo no SGCQ com sucesso!", "Excelente!", "success")));
      }
      this.show = !this.show;
    },

    call(cliente) {
      this.show = !this.show;
      this.editing = cliente;
    },
  },

  setup() {
    const store = useSgcqStore();
    const clienteStore = useClienteStore();

    return {
      store,
      clienteStore,
    };
  },
};
</script>

<style lang="scss" scoped></style>
